﻿/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';

export class taskreference extends IceEntity {
    task_key = "";
    record_version = 0;
    offline_record_status = 0;

    gettablename(): string {
        return "TASK_REFERENCE";
    }
}
